<div class="modal-content">
    <div class="modal-body  p-md-2 p-3 overflow-auto ">
        <button type="button" class="close" (click)="onClose()">&times;</button>
        <div class="text-center pt-3">
            <div class="title home-heading">Sign in to save for later</div>
            <p class="title fs-5 text-bold home-description vpt-1 ">
                plus get curated picks, exclusive promo codes, and
                <br />help other members find the best pieces.
            </p>
            <p class="sub-description ">Already a member? 
                <a class="a-link" (click)="openSigninPopup()">
                    Sign in Here!
                </a>
            </p>
        </div>
        <div class="row m-0 p-0 py-2 px-md-5">
            <q-dform [isNew]="true" [fields]="formFields" [formData]="{}"></q-dform>
            <div class="d-flex term-policy-link">
                <a href="/terms" target="_blank">Terms</a>
                <span class="mx-2">and</span> 
                <a href="/privacy" target="_blank">Privacy Policy</a>
            </div>
        </div>
        <div class="text-center vmt-2 vmb-1 mx-auto">
            <q-button class="purple-button" [disabled]="uikitFormComponent?.form?.invalid || loading" 
                title="Join Qatch" (click)="validateEmail();" [loading]="loading">
            </q-button>
        </div>
        <div class="mb-3 d-flex flex-column align-items-center">
            <button class="btn btn-link text-decoration-none p-0" (click)="onClose()"
                style="font-size: .85rem; color: #999;">Maybe later</button>
        </div>
    </div>